import { render, staticRenderFns } from "./WelcomeLeadgen.vue?vue&type=template&id=44e4079a"
import script from "./WelcomeLeadgen.vue?vue&type=script&lang=js"
export * from "./WelcomeLeadgen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports